var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
let CurriculumInventorySequenceBlock = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = attr('number'), _dec5 = attr('number'), _dec6 = attr('number'), _dec7 = attr('number'), _dec8 = attr('boolean'), _dec9 = attr('date'), _dec10 = attr('date'), _dec11 = attr('number'), _dec12 = belongsTo('curriculum-inventory-academic-level', {
  async: true,
  inverse: 'startingSequenceBlocks'
}), _dec13 = belongsTo('curriculum-inventory-academic-level', {
  async: true,
  inverse: 'endingSequenceBlocks'
}), _dec14 = belongsTo('curriculum-inventory-sequence-block', {
  async: true,
  inverse: 'children'
}), _dec15 = hasMany('curriculum-inventory-sequence-block', {
  async: true,
  inverse: 'parent'
}), _dec16 = belongsTo('curriculum-inventory-report', {
  async: true,
  inverse: 'sequenceBlocks'
}), _dec17 = hasMany('session', {
  async: true,
  inverse: null
}), _dec18 = hasMany('session', {
  async: true,
  inverse: null
}), _dec19 = belongsTo('course', {
  async: true,
  inverse: null
}), _class = class CurriculumInventorySequenceBlock extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "required", _descriptor3, this);
    _initializerDefineProperty(this, "childSequenceOrder", _descriptor4, this);
    _initializerDefineProperty(this, "orderInSequence", _descriptor5, this);
    _initializerDefineProperty(this, "minimum", _descriptor6, this);
    _initializerDefineProperty(this, "maximum", _descriptor7, this);
    _initializerDefineProperty(this, "track", _descriptor8, this);
    _initializerDefineProperty(this, "startDate", _descriptor9, this);
    _initializerDefineProperty(this, "endDate", _descriptor10, this);
    _initializerDefineProperty(this, "duration", _descriptor11, this);
    _initializerDefineProperty(this, "startingAcademicLevel", _descriptor12, this);
    _initializerDefineProperty(this, "endingAcademicLevel", _descriptor13, this);
    _initializerDefineProperty(this, "parent", _descriptor14, this);
    _initializerDefineProperty(this, "children", _descriptor15, this);
    _initializerDefineProperty(this, "report", _descriptor16, this);
    _initializerDefineProperty(this, "sessions", _descriptor17, this);
    _initializerDefineProperty(this, "excludedSessions", _descriptor18, this);
    _initializerDefineProperty(this, "course", _descriptor19, this);
  }
  get isRequired() {
    return 1 === parseInt(this.required, 10);
  }
  get isOptional() {
    return 2 === parseInt(this.required, 10);
  }
  get isRequiredInTrack() {
    return 3 === parseInt(this.required, 10);
  }
  get isOrdered() {
    return 1 === parseInt(this.childSequenceOrder, 10);
  }
  get isUnordered() {
    return 2 === parseInt(this.childSequenceOrder, 10);
  }
  get isParallel() {
    return 3 === parseInt(this.childSequenceOrder, 10);
  }

  /**
   * A list of all ancestors (parent, its parents parent etc) of this sequence block.
   * First element of the list is the block's direct ancestor (parent), while the last element is the oldest ancestor.
   * Returns a promise that resolves to an array of sequence block objects.
   * If this sequence block is a top-level block within its owning report, then that array is empty.
   */
  async getAllParents() {
    const parent = await this.parent;
    if (!parent) {
      return [];
    }
    const parentsAncestors = await parent.getAllParents();
    return [parent, ...parentsAncestors];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "required", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "childSequenceOrder", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "orderInSequence", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "minimum", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "maximum", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "track", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "startDate", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "endDate", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "duration", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "startingAcademicLevel", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "endingAcademicLevel", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "parent", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "children", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "report", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "sessions", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "excludedSessions", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "course", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CurriculumInventorySequenceBlock as default };